module.exports = __webpack_public_path__ + "static/media/btn-clickaction.9d297f66.svg";